<!--
 * @Author: zhaozhuo
 * @Date: 2021-10-11 16:49:24
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-16 14:58:15
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { Config } from '@/config'
export default {
	data() {
		return {}
	},
	created() {
		document.title = Config.webTitle
	},
	methods: {}
}
</script>
<style lang="scss">
  @import "@/assets/css/base.scss";
  @import "@/assets/css/common.scss";
  #app {
    @include size();
  }
</style>